<ion-button
  class="time-toggle-button"
  fill="solid"
  (click)="toggleMode()"
  [attr.title]="tooltipText">
  <ion-icon [name]="iconName" slot="icon-only"></ion-icon>
</ion-button>
